import { Obj } from "../internal";
/**
 *    Project        : infraVIS Engine
 *    Organization   : University of Applied Sciences and Arts Northwestern Switzerland
 *    Department     : Institute of Geomatics Engineering
 *    Copyright      : Copyright (c) 2014 by FHNW. All rights reserved.
 */
/*******************************************************************************
 Project       : Smart Mobile Mapping
 Purpose       : Geometry
 Copyright     : Copyright (c) 2012 by FHNW. All rights reserved.
 *******************************************************************************/
export var GEOMETRYTYPE;
(function (GEOMETRYTYPE) {
    GEOMETRYTYPE[GEOMETRYTYPE["UNDEFINED"] = -1] = "UNDEFINED";
    GEOMETRYTYPE[GEOMETRYTYPE["POINT"] = 0] = "POINT";
    GEOMETRYTYPE[GEOMETRYTYPE["MULTIPOINT"] = 1] = "MULTIPOINT";
    GEOMETRYTYPE[GEOMETRYTYPE["LINESTRING"] = 2] = "LINESTRING";
    GEOMETRYTYPE[GEOMETRYTYPE["MULTILINESTRING"] = 3] = "MULTILINESTRING";
    GEOMETRYTYPE[GEOMETRYTYPE["POLYGON"] = 4] = "POLYGON";
    GEOMETRYTYPE[GEOMETRYTYPE["MULTIPOLYGON"] = 5] = "MULTIPOLYGON";
})(GEOMETRYTYPE || (GEOMETRYTYPE = {}));
/**
 * Representation of the FeatureCollection-Object specified in GeoJSON-Standard.
 */
export class Geometry extends Obj {
    constructor(parentfeature) {
        super();
        /**
         * The GeoJSON type. Should always be "Feature"
         * @property {GEOMETRYTYPE} type
         */
        this.type = -1;
        this.coordinates = [];
        /**
         * The unique geometry id.
         * @property {Number} id
         */
        this.id = null;
        this.created = false;
        this._visible = true;
        this.hightlighted = false;
        this.id = Math.floor(Math.random() * 10000000000000001);
        this.parentfeature = parentfeature;
    }
    /**
     * Parse the Geometry from a JSON-Object
     * @method parseFromJSON
     * @param {Object} json The JSON Object
     */
    parseFromJSON(json) {
        return;
    }
    /**
     * returns the Geometry content as GeoJson string
     * @method toGeoJsonString
     * @return {string}
     */
    toGeoJsonString() {
        return "";
    }
    movePoint(newcoord, index) {
        return;
    }
    /**
     * Insert a point in the geomtery at a certain position
     * @method insertPoint
     * @param {number[]} newcoord
     * @param {number} index
     */
    insertPoint(newcoord, index) {
        return;
    }
    /**
     * Delete a point in the geomtery at a certain position
     * @method deletePoint
     * @param {number} index
     */
    deletePoint(index) {
        return;
    }
    /**
     * clear coordinates
     * @method clear
     */
    clear() {
        return;
    }
    /**
     * Removes the Geometry from the Render-Engine and destroys it.
     * @method destroy
     */
    destroy() {
        return;
    }
    /**
     * Shows the geometry in Higlight-Style
     * @method highlightOn
     */
    highlightOn() {
        this.hightlighted = true;
    }
    /**
     * Shows the geometry in Higlight-Style
     * @method highlightOff
     */
    highlightOff() {
        this.hightlighted = false;
    }
    /**
     * Updates the Geometry
     * @method update
     */
    update() {
        return;
    }
    /**
     * Shows the Geometry. It sets hide to false and updates the geometry.
     * @method show
     */
    show() {
        this._visible = true;
    }
    /**
     * Hides the Geometry. It sets hide to true and updates the geometry.
     */
    hide() {
        this._visible = false;
    }
    /**
     * Repsond whether geometry is visible or not
     *
     * @method isVisible
     * @return {boolean}
     */
    isVisible() {
        return this._visible;
    }
    /**
     * Static Function to convert the Geometry-Enum to a string.
     *
     * @param {number} type
     * @return {string}
     */
    static toString(type) {
        switch (type) {
            case GEOMETRYTYPE.UNDEFINED:
                return "undefined";
            case GEOMETRYTYPE.POINT:
                return "Point";
            case GEOMETRYTYPE.LINESTRING:
                return "LineString";
            case GEOMETRYTYPE.POLYGON:
                return "Polygon";
            case GEOMETRYTYPE.MULTIPOINT:
                return "MultiPoint";
            case GEOMETRYTYPE.MULTILINESTRING:
                return "MultiLineString";
            case GEOMETRYTYPE.MULTIPOLYGON:
                return "MultiPolygon";
        }
        return "";
    }
    /**
     * static function to convert the geometry-type-string to the geometry-enum.
     * @method toNumber
     * @param {string} type
     * @return {number}
     */
    static toNumber(type) {
        if (typeof type == "number")
            return type;
        switch (type) {
            case "undefined":
                return GEOMETRYTYPE.UNDEFINED;
            case "Point":
                return GEOMETRYTYPE.POINT;
            case "LineString":
                return GEOMETRYTYPE.LINESTRING;
            case "Polygon":
                return GEOMETRYTYPE.POLYGON;
            case "MultiPoint":
                return GEOMETRYTYPE.MULTIPOINT;
            case "MultiLineString":
                return GEOMETRYTYPE.MULTILINESTRING;
            case "MultiPolygon":
                return GEOMETRYTYPE.MULTIPOLYGON;
        }
        return -1;
    }
    pick(mx, my, array) {
        return;
    }
}
//# sourceMappingURL=geometry.js.map